export default function DiscoverTabContent() {
  return (
    <div
      className="relative flex flex-col items-center justify-center overflow-hidden rounded-2xl"
      style={{ minHeight: 300 }}
    >
      {/* Deep purple gradient background */}
      <div
        className="absolute inset-0 rounded-2xl"
        style={{
          background:
            "linear-gradient(145deg, #1a0633 0%, #0e0420 40%, #17062e 70%, #0a0318 100%)",
          border: "1px solid oklch(49.6% 0.265 301.924 / 0.22)",
        }}
      />

      {/* Radial glow — centre */}
      <div
        className="absolute"
        style={{
          width: 260,
          height: 260,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background:
            "radial-gradient(circle, oklch(49.6% 0.265 301.924 / 0.28) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
        }}
      />

      {/* Subtle top-right accent */}
      <div
        className="absolute top-0 right-0"
        style={{
          width: 120,
          height: 120,
          background:
            "radial-gradient(circle, oklch(70% 0.2 301.924 / 0.15) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
        }}
      />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-8 py-10">
        {/* Icon ring */}
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
          style={{
            background: "oklch(49.6% 0.265 301.924 / 0.18)",
            border: "1px solid oklch(49.6% 0.265 301.924 / 0.35)",
            boxShadow: "0 0 32px oklch(49.6% 0.265 301.924 / 0.25)",
          }}
        >
          {/* Sparkle SVG — safe inline, no lucide import needed */}
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="oklch(80% 0.18 301.924)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/>
          </svg>
        </div>

        {/* Stars decoration */}
        <div
          className="flex gap-3 mb-4"
          style={{ color: "oklch(70% 0.18 301.924)", opacity: 0.7 }}
        >
          <span style={{ fontSize: 10 }}>✦</span>
          <span style={{ fontSize: 14 }}>✦</span>
          <span style={{ fontSize: 10 }}>✦</span>
        </div>

        <p
          className="font-bold mb-2"
          style={{
            fontSize: "1.3rem",
            color: "#fff",
            letterSpacing: "-0.01em",
          }}
        >
          Coming Soon
        </p>

       

        {/* Bottom stars */}
        <div
          className="flex gap-3 mt-5"
          style={{ color: "oklch(70% 0.18 301.924)", opacity: 0.5 }}
        >
          <span style={{ fontSize: 10 }}>✦</span>
          <span style={{ fontSize: 14 }}>✦</span>
          <span style={{ fontSize: 10 }}>✦</span>
        </div>
      </div>
    </div>
  );
}
